export default "__VITE_ASSET__B1DXWsF9__"